import Footnote from "./footnote";

const Motivations = () => {
  return (
    <section className="content-section">
      <h2>Motivations</h2>
      <p>
        Why do people use steroids? There are many reasons, such as wanting to gain muscle and
        improve physical appearance. These motivations can also evolve over age. For example, 
        men under 35 are generally more motivated to improve
        their strength compared to men over 35.<Footnote num={1}/>
      </p>
      <p>
        <b>Steroid use sometimes overlaps with muscle dysphoria. </b>
        Some guys who use testosterone do so because they have discomfort with how they see their
        body. A mental health condition known as <a href="https://www.nature.com/articles/s41598-018-27176-9#:~:text=Muscle%2520Dysmorphia%2520(MD)%2520is%2520a%2520subtype%2520of%2520Body%2520Dysmorphic%2520Disorder,normal%2520or%2520very%2520muscular2.">Muscle Dysmorphia</a> is when people have misperceptions
        as to how "big" they really are, often thinking that they're not muscular enough no matter
        how much muscle they really have. Some researchers have called this condition "<a href="https://pubmed.ncbi.nlm.nih.gov/18759381/">bigorexia</a>" given
        its parallels with anorexia.
      </p>
      <p>
        The <a href="https://www.sciencedirect.com/science/article/pii/S1740144504000269?via=ihub">Muscle Dysmorphia Disorder Inventory</a> (or MDDI) is a screening tool that can be used to evaluate for muscle dysmorphia. Strongly agreeing with the following statements may be an indication of muscle dysmorphia:
      </p>
      <ul>
        <li>I think my body is too skinny/slender. </li>
        <li>I wear loose clothing so people can't see my body. </li>
        <li>I hate my body. </li>
        <li>I wish I could be heavier. </li>
        <li>I find my chest to be too small. </li>
        <li>I think my legs are too thin. </li>
        <li>I feel like I have too much body fat. </li>
        <li>I wish my arms were stronger. </li>
        <li>I am embarrassed to let people see me without ta shirt or t-shirt. </li>
        <li>I feel anxious when I miss one or more days of exercise. </li>
        <li>I cancel social activities with friends because of my workout/exercise schedule. </li>
        <li>I feel depressed when I miss one or more days of exercise. </li>
        <li>I miss opportunities to meet new people because of my workout schedule. </li>
      </ul>
      <p>
        <span class="highlight">If you think you may have muscle dysmorphia, speak with your doctor.</span> No amount of steroids 
        or exercise can treat muscle dysmorphia, but working with a doctor and mental health practitioner
        can help.
      </p>
    </section>
  )
}

export default Motivations;